export default __webpack_public_path__ + "static/media/fingerprint.007e4a50.svg";